__turbopack_context__.v({
  "callableTitle": "CallableTitle-module-scss-module__gdeRvq__callableTitle",
  "name": "CallableTitle-module-scss-module__gdeRvq__name",
  "parameters": "CallableTitle-module-scss-module__gdeRvq__parameters",
});
